const MenuIcon = (props) => {
  return (
    <svg
      viewBox="0 0 24.00 24.00"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="0.672"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g id="Menu / Menu_Alt_02">
          {" "}
          <path
            id="Vector"
            d="M11 17H19M5 12H19M11 7H19"
            stroke="#ffffff"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export default MenuIcon;
